import { render, staticRenderFns } from "./ApeTable.vue?vue&type=template&id=4fe70fb1"
import script from "./ApeTable.vue?vue&type=script&lang=js"
export * from "./ApeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports